import { render, staticRenderFns } from "./AllDocument.vue?vue&type=template&id=3e0afd96"
import script from "./AllDocument.vue?vue&type=script&lang=ts"
export * from "./AllDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports